import React from "react";

/**
 * Wordmark — "Sam Erpik" in a pixel face, with the dot of the i drawn as a
 * yellow pixel (the nav underline colour). The visible text uses a dotless
 * "ı" so the dot can be drawn, so screen readers get the plain name instead.
 * Dot size/offset are measured from Pixelify Sans's own "i" (in em, at line-height 1).
 *
 * @param {boolean} version  show the "v10.2" tag (10 years of shipping)
 * @param {string}  size     Tailwind font-size class for the name
 */
const VERSION = "v10.2";
const VERSION_NOTE = "10 years of shipping · latest release: Purple Luna";

export default function Wordmark({ version = false, size = "text-[21px]" }) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="sr-only">Sam Erpik</span>
      <span aria-hidden="true" className={`font-pixel font-semibold leading-none text-ink ${size}`}>
        Sam Erp
        <span className="relative inline-block">
          ı
          <span className="absolute left-1/2 top-[0.18em] h-[0.13em] w-[0.12em] -translate-x-1/2 bg-[#FFD93D]" />
        </span>
        k
      </span>
      {version && (
        <span
          aria-hidden="true"
          title={VERSION_NOTE}
          className="relative -top-2 rounded-[4px] border border-black/10 px-1 py-[3px] font-mono text-[10px] font-semibold leading-none text-mute dark:border-white/15"
        >
          {VERSION}
        </span>
      )}
    </span>
  );
}
